import { render, staticRenderFns } from "./CryptoFashion.vue?vue&type=template&id=2d8be06a"
import script from "./CryptoFashion.vue?vue&type=script&lang=js"
export * from "./CryptoFashion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports